<template>
  <div>
    <vs-popup :title="$t('DeleteWrongBarcode')" :active.sync="showModal">
        <div class="flex">
            <div class="vx-col lg:w-5/12 w-full">
          <vs-input
            class="inputx"
            v-model="info.serial"
            name="serialName"
            :label="$t('SerialNumber')"
            @keyup.enter="deleteSerial()"
            v-validate="'required'"
          />
          <span
            class="text-danger text-sm mt-3"
            v-show="errors.has('serialName')"
            >{{ errors.first("serialName") }}</span
          >
        </div>
        <div class="vx-col lg:w-1/12 w-full mt-6 mr-5">
          <vs-button
            size="small"
            radius
            color="danger"
            type="gradient"
            icon-pack="feather"
            icon="icon-x"
            @click.prevent="deleteSerial()"
            class="mb-2 mt-2 lfloat"
          ></vs-button>
        </div>
        </div>
       
     </vs-popup>
  </div>
</template>
<script>
export default {
    data() {
    return {
      info: {
        serial: "",
      },
    };
  },
  props: {
    show: { default: false },

  },
  computed: {
    showModal: {
      get: function () {
        this.info.serial = "";
        return this.show;
      },
      set: function () {
        this.info.serial = "";
        this.$emit("close");

      },
    },
  },
  methods:{
    deleteSerial(){
        this.$emit("deleteSerials" ,this.info.serial);
    }
  }
};
</script>
